import {NgModule} from '@angular/core';
import {TableLayerDialogComponent} from './table-layer-dialog.component';
import {GlobalModule} from '../../../../core/global.module';
import {DynamicFieldsModule} from '../../../dynamic-fields/dynamic-fields.module';
import {AppDialogModule} from '@components/dialog/modules/app-dialog.module';
import {PanelToolsModule} from '@components/panel-tools/panel-tools.module';
import {ButtonModule} from '@components/button/modules/button.module';


@NgModule({
    declarations: [TableLayerDialogComponent],
    imports: [
        GlobalModule,
        DynamicFieldsModule,
        AppDialogModule,
        PanelToolsModule,
        ButtonModule,
    ],
    exports: [TableLayerDialogComponent]
})
export class TableLayerDialogModule {
}
